<ng-template #template>
    <div class="pecas-canceladas">
        <div class="modal-header">
            <h4 class="modal-title">{{ 'geral.notificacao.peca-cancelada.modal.titulo' | translate }}{{notificacaoSelecionada?.order_id}}</h4>
            <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="modal_fechar();"></button>
        </div>
        <div class="modal-body">
            @if (this.userService.userIsCentral()) {
                <div>
                    <label class="oficina">
                        {{ 'geral.notificacao.peca-cancelada.modal.oficina' | translate }}
                    </label>
                    <span>{{ notificacaoSelecionada?.repairer_name }}</span>
                </div>
            }
            <label class="veiculo">
                {{ (settingService.isMercadoPartsfy(notificacaoSelecionada?.veiculo) ? 'geral.notificacao.peca-cancelada.modal.pedido' : 'geral.notificacao.peca-cancelada.modal.veiculo') | translate }}
            </label>
            <span>{{ notificacaoSelecionada?.veiculo }}</span>
            <br />
            @if (notificacaoSelecionada?.parts?.length <= 0) {
                <h4 class="cta">{{ 'geral.notificacao.peca-cancelada.modal.message-vazio' | translate }}</h4>
            } @else {
                <div>
                    <h4 class="cta">{{ (settingService.isMercadoPartsfy(notificacaoSelecionada?.veiculo) ? 'geral.notificacao.peca-cancelada.modal.message.mercado' : 'geral.notificacao.peca-cancelada.modal.message.padrao') | translate }}</h4>
                    <div class="box-pecas">
                        <ng-scrollbar>
                            <table class="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td class="w_ninety"><b>{{ 'buyer.pecas-canceladas.cabecalho.peca-nome' | translate}}</b></td>
                                        @if (!settingService.isMercadoPartsfy(notificacaoSelecionada?.veiculo)) {
                                            <td class="w_five">
                                                <div class="form-check c-checkbox needsclick checkboxcot">
                                                    <label class="needsclick">
                                                        <input type="checkbox" class="needsclick" (click)="notificacao_selecionarTodasPecas($event);">
                                                        <span class="fa fa-check"></span>
                                                    </label>
                                                </div>
                                            </td>
                                        }
                                    </tr>
                                    @for (peca of notificacaoSelecionada.parts; track peca) {
                                        <tr>
                                            <td>
                                                {{peca.nome_peca}}
                                                @if (peca.cancel_reason) {
                                                    <small class="cancel-reason">
                                                        ({{ 'buyer.pecas-canceladas.motivo' | translate}}{{peca.notes == null ? peca.cancel_reason : peca.notes}})
                                                    </small>
                                                }
                                            </td>
                                            @if (!settingService.isMercadoPartsfy(notificacaoSelecionada?.veiculo)) {
                                            <td>
                                                <div class="form-check c-checkbox needsclick checkboxcot">
                                                <label class="needsclick">
                                                    <input type="checkbox" class="needsclick peca_notificacao" (click)="notificacao_selecionarPeca(peca, $event);">
                                                    <span class="fa fa-check"></span>
                                                </label>
                                                </div>
                                            </td>
                                            }
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </ng-scrollbar>
                    </div>
                </div>
            }

        </div>
        <div class="modal-footer">
            <button id="ignorarNotificacao" type="button" class="btn btn-warning" (click)="atualizarNotificacao(1, 0);">{{ 'buyer.pecas-canceladas.botoes.ignorar' | translate}}</button>
            <button id="reabrirNotificacao" type="button" class="btn btn-primary" (click)="atualizarNotificacao(settingService.isMercadoPartsfy(notificacaoSelecionada?.veiculo) ? 3 : 2, 0);" [disabled]="!settingService.isMercadoPartsfy(notificacaoSelecionada?.veiculo) && !notificacao_habilitaReabrir()">
                {{ (settingService.isMercadoPartsfy(notificacaoSelecionada?.veiculo) ? 'buyer.pecas-canceladas.botoes.recomprar' : 'buyer.pecas-canceladas.botoes.reabrir') | translate}}
            </button>
            <button id="closeModal" type="button" class="btn btn-light" (click)="modal_fechar();">{{ 'buyer.pecas-canceladas.botoes.fechar' | translate}}</button>
        </div>
        <ngx-loading [show]="loading" [template]="templateNotificacoes"></ngx-loading>
    </div>
</ng-template>

<ng-template #templateNotificacoes></ng-template>
